import * as React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { IconWithText } from '@components/icon-with-text'

interface Props {
  handleClose: () => void
  onResignation: () => void
}

export const CashbackVoucherCheckoutModal = ({ handleClose, onResignation }: Props): JSX.Element => {
  const handleMoveToTheNextStep = () => {
    onResignation()
    handleClose()
  }

  return (
    <Modal.Body>
      <div className="p-2 d-flex flex-column justify-content-center">
        <div className="position-relative mx-auto mt-4 mb-5">
          <div
            className="position-absolute start-50 top-50 translate-middle rounded-circle border border-2"
            style={{ width: '70px', height: '70px' }}
          />
          <i className="font-size-icon-sm mt-2 mb-4 uil-pricetag-alt text-muted" />
        </div>
        <p className="fw-bold font-size-lg col-10 mx-auto text-center">
          Czy jesteś pewien, że rezygnujesz <span className="text-nowrap">z promocji rePLAY?</span>
        </p>
        <p className="col-11 mx-auto text-center">
          Aby skorzystać z promocji zapoznaj się z warunkami oferty znajdującej się pod podsumowaniem pobytu oraz
          zaznacz chęć wzięcia udziału.
        </p>
        <div className="d-flex justify-content-center">
          <Button
            variant="primary"
            onClick={handleClose}
            className="text-white px-3 btn-tall mt-3 font-weight-semibold font-10 me-1 col-6 d-flex justify-content-center align-items-center"
          >
            <IconWithText text="Chcę skorzystać" iconClassName="uil-check font-size-xxl me-2" />
          </Button>
          <Button
            variant="secondary"
            onClick={handleMoveToTheNextStep}
            className="text-white px-3 btn-tall mt-3 font-weight-semibold font-10 ms-1 col-6 d-flex justify-content-center align-items-center"
          >
            <IconWithText
              text="Przechodzę dalej"
              iconClassName="uil-angle-right font-size-xxl ms-2"
              className="flex-row-reverse"
            />
          </Button>
        </div>
      </div>
    </Modal.Body>
  )
}
